import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Renders marketing-site chrome (Header, Footer, modals, etc.)
 * EXCEPT on routes that are full-screen apps (/portal/*).
 */
export default function MarketingChrome({ children }) {
  const { pathname } = useLocation();
  if (pathname.startsWith('/portal')) return null;
  return <>{children}</>;
}
